export default __webpack_public_path__ + "static/media/maze2.5cc672c9.png";